/** Frontmatter for the "streaming-defense-and-kicker" article; the Body lives in streaming-defense-and-kicker.jsx. */
const meta = {
  slug: 'streaming-defense-and-kicker',
  title: 'Streaming Defenses and Kickers',
  category: 'Streaming',
  excerpt: 'Stop drafting a defense in the double-digit rounds. Play the matchup every week instead. Here is the streaming playbook.',
  readMinutes: 4,
  date: '2026-07-20',
};

export default meta;
